module.exports = __webpack_public_path__ + "media/images/athletes/2521-f2aef95ada8ec796c04c8a444c554a96.png";